import { DEFAULT_CART_REMIND_DELAY_MINUTES } from "../../../../config/constansts";
import { BaseSettingsClient } from "../types/clients";
import { AppSettings } from "@core/types";
import { Config } from "../config";

export type ParhatoAppSettings = {
  [k: string]: string;
};

export type WooComPages = {
  id: string;
  content: {
    protected: boolean;
    rendered: string;
  };
  slug: string;
}[];

type ParhatoSupaAppSettings = {
  app: AppSettings;
};

class SettingsClient extends BaseSettingsClient {
  async getSettings() {
    const settings = (
      await this.instance.get<ParhatoAppSettings>(
        "/api/ionicbecruxsettings/ionic_becrux_get_all_settings/?insecure=cool",
      )
    ).data;

    const ids = [
      settings.about_page_id || undefined,
      settings.refund_page_id || undefined,
      settings.terms_page_id || undefined,
    ];

    const includes = ids.filter((item) => Boolean(item)).join(",");
    const { data } = await this.instance.get<WooComPages>(`/wp-json/wp/v2/pages/?include=${includes}`);
    const { data: supaSettings } = await this.instance.get<ParhatoSupaAppSettings>("/wp-json/parhato-api/v1/settings");

    const pages: { [k: string]: string } = data.reduce(
      (result, page) => ({ ...result, [page.id]: page.content.rendered }),
      {},
    );

    const appSettings: Partial<AppSettings> = {
      contactUsPage: pages[settings.about_page_id],
      newVersionAlertTitle: settings.new_version_alert_title,
      newVersionAlertMessage: settings.new_version_alert_message,
      newVersionAlertButtonText: settings.new_version_alert_button_text,
      minVersionAndroid: settings.min_version_android,
      minVersionIOS: settings.min_version_ios,
      notifications: {
        cartRemindDelayMinutes: settings.cart_remind_delay_minutes
          ? parseInt(settings.cart_remind_delay_minutes)
          : DEFAULT_CART_REMIND_DELAY_MINUTES,
      },
      ...{ ...Config, ...supaSettings?.app },
      isExpressDeliveryEnabled: !!settings.isExpressDeliveryEnabled,
      minimumOrderAmount: parseInt(settings.order_minimum_amount) ?? 500,
      showNewVersionAlert: settings.show_new_version_alert === "yes",
    };

    return appSettings;
  }
}

export default SettingsClient;
